import React from 'react';
import { Container } from 'reactstrap';
import { useParams } from 'react-router-dom';
import camelcaseKeys from 'camelcase-keys';
import { PseudoStates, useFetch } from '@cordata/buffet';

import { CitProvider } from '~/utils/cit/context';

import { PageLayout, Navbar } from '~/components';
import Form from '~/components/CIT/Form';

const CitSubmission = () => {
  const { submissionId } = useParams();
  const [status, data] = useFetch(`data/public/cit-submission/${submissionId}`, { instance: 'p' });

  const transformData = () => {
    const formData = {
      id: data.id,
      approvalStatus: data.attributes.status,
      ...camelcaseKeys(JSON.parse(data.attributes.submissionJson)),
    };

    if (formData.birthDate) {
      formData.birthDate = new Date(formData.birthDate);
    }

    if (formData.dateTime) {
      formData.dateTime = new Date(formData.dateTime);
    }

    return formData;
  };

  return (
    <PageLayout
      Header={Navbar}
      title="CIT Submission"
    >
      { status === 'success' ? (
        <Container>
          <CitProvider>
            <Form data={transformData()} />
          </CitProvider>
        </Container>
      ) : (
        <PseudoStates isLoading={status === 'loading'} error={status === 'error'} />
      )}
    </PageLayout>
  );
};

export default CitSubmission;
